import { useEffect, useState } from "react";
import OlMap from "../Map/OlMap";
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Geometry } from "geojson";
import { Eye } from "lucide-react";
import { DEFAULT_MAP_CENTER, type LatLng } from "@/src/lib/procedureMapView";

export type Center = {
  center: LatLng;
};
export type Parcel = { id: string; geometry: (Geometry & Center) | (Geometry & Center)[] };
function ParcelPreview({ parcel }: { parcel: Parcel }) {
  const [latLng, setLatLng] = useState<LatLng>(DEFAULT_MAP_CENTER);
  useEffect(() => {
    const geo = Array.isArray(parcel?.geometry) ? parcel.geometry[0] : parcel?.geometry;
    if (geo?.center) setLatLng(geo.center);
  }, [parcel]);

  const geometries = parcel?.geometry
    ? (Array.isArray(parcel.geometry) ? parcel.geometry : [parcel.geometry]).map((g, i) => ({ id: `${parcel.id}-${i}`, geometry: g }))
    : [];

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Eye />
      </DialogTrigger>
      <DialogContent className="max-w-[1225px]">
        <DialogTitle>{parcel.id}</DialogTitle>
        <div className="flex">
          <div className="min-h-[350px] h-[70vh] w-full">
            <OlMap latLng={latLng} setLatLng={setLatLng} selectedParcelsGeometries={geometries} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ParcelPreview;
